import { computed } from 'vue';
import { useProduct } from '@modules/product';
import { useProductType } from '@composables/useProductType';
import useUpc from '@modules/upc/composables/useUpc';
import useSelected2ndVariant from '@modules/third-variant/composables/useSelected2ndVariant';

/**
 *
 * @returns {import('vue').ComputedRef<string>}
 */
export default function useSelectedMemberId() {
  const { productData: product, productId } = useProduct();
  const { isConsolidatedPage } = useProductType();

  if (!isConsolidatedPage) {
    return computed(() => productId);
  }

  const { selectedUpcId, upcData } = useUpc();
  const { selected2ndVariantName } = useSelected2ndVariant();
  const latchKeyProductIdsByGroup = product?.detail?.memberDisplayGroupsMap || {};

  return computed(() => {
    const selectedLatchkeyGroup = latchKeyProductIdsByGroup[selected2ndVariantName.value] || [];
    const [selectedMemberIdFromSelectedLatchkey] = selectedLatchkeyGroup;
    if (selectedLatchkeyGroup.length === 1 && selectedMemberIdFromSelectedLatchkey) {
      return selectedMemberIdFromSelectedLatchkey;
    }
    const selectedMemberIdFromSelectedUpc = upcData.value.upcs[selectedUpcId.value]?.relationships?.selectedProduct;

    return selectedMemberIdFromSelectedUpc || selectedMemberIdFromSelectedLatchkey || productId;
  });
}
